import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';
import { useInstanceId } from '../../../../hooks';
import { bridge } from '../../../bridge';

type MoveToCategoryProps = {
  deeplink: string;
};

/**
 * 딥링크 쿼리스트링에서 키에 해당하는 값을 원문 그대로 반환.
 *
 * RN의 URL 폴리필이 `ably://` 같은 custom scheme에서 쿼리 값 끝의 `=`
 * (예: base64 padding)을 잘라먹는 이슈가 있어, `URL.searchParams` 대신 직접 파싱.
 */
const getQueryParam = (deeplink: string, key: string): string | null => {
  const match = deeplink.match(new RegExp(`[?&]${key}=([^&]*)`));
  return match ? match[1] : null;
};

const parseScreensDeeplink = (deeplink: string) => {
  const screenName = getQueryParam(deeplink, 'screen_name');
  const nextToken = getQueryParam(deeplink, 'next_token');

  return {
    screen_name: screenName,
    next_token: nextToken ?? '',
  };
};

export const useMoveToCategory = () => {
  const navigation = useRootStackNavigation();
  const instanceId = useInstanceId();

  return useCallback(
    ({ deeplink }: MoveToCategoryProps) => {
      const params = parseScreensDeeplink(deeplink);

      bridge.openDeeplink(deeplink, {
        webCallback: () => {
          navigation.push('Screens', {
            instanceId,
            ...params,
          });
        },
      });
    },
    [navigation, instanceId],
  );
};
